import { createRouter, createWebHashHistory } from 'vue-router'

import PageHome from '@/views/PageHome.vue'
import BeritaOPD from '@/views/berita/BeritaOPD.vue'
import isi_berita from '@/views/berita/isi_berita.vue'
import VisiMisi from '@/views/profil/VisiMisi.vue'
import TugasPokok from '@/views/profil/TugasPokok.vue'
import StrukturOrganisasi from '@/views/profil/StrukturOrganisasi.vue'
import ProfilPegawai from '@/views/profil/ProfilPegawai.vue'
// import KebijakanOPD from '@/views/profil/KebijakanOPD.vue'



import BidangTangkap from '@/views/unit_kerja/BidangTangkap.vue'
import BidangBudidaya from '@/views/unit_kerja/BidangBudidaya.vue'
import BidangDayasaing from '@/views/unit_kerja/BidangDayasaing.vue'
import SekretariatOPD from '@/views/unit_kerja/SekretariatOPD.vue'

import KelayakanPengelolaan from '@/views/layanan/KelayakanPengelolaan.vue'
import SertifikasiBudidayaIkan from '@/views/layanan/SertifikasiBudidayaIkan.vue'
import PembenihanIkan from '@/views/layanan/PembenihanIkan.vue'
import AngkutIkan from '@/views/layanan/AngkutIkan.vue'
import TangkapIkan from '@/views/layanan/TangkapIkan.vue'
import UsahaPerikanan from '@/views/layanan/UsahaPerikanan.vue'

import DataUPTD from '@/views/data/DataUPTD.vue'
import DataPeraturan from '@/views/data/DataPeraturan.vue'

import FotoOPD from '@/views/galeri/FotoOPD.vue'
import VideoOPD from '@/views/galeri/VideoOPD.vue'

const routes = [
  { path: '/', name: 'home', component: PageHome },
  { path: '/BeritaOPD', name: 'BeritaOPD', component: BeritaOPD },
  { path: '/isi_berita', name: 'isi_berita', component: isi_berita },
  { path: '/VisiMisi', name: 'VisiMisi', component: VisiMisi },
  { path: '/TugasPokok', name: 'TugasPokok', component: TugasPokok },
  { path: '/StrukturOrganisasi', name: 'StrukturOrganisasi', component: StrukturOrganisasi },
  { path: '/ProfilPegawai', name: 'ProfilPegawai', component: ProfilPegawai },
  // { path: '/KebijakanOPD', name: 'KebijakanOPD', component: KebijakanOPD },


  { path: '/BidangTangkap', name: 'BidangTangkap', component: BidangTangkap },
  { path: '/BidangBudidaya', name: 'BidangBudidaya', component: BidangBudidaya },
  { path: '/BidangDayasaing', name: 'BidangDayasaing', component: BidangDayasaing },
  { path: '/SekretariatOPD', name: 'SekretariatOPD', component: SekretariatOPD },


  { path: '/KelayakanPengelolaan', name: 'KelayakanPengelolaan', component: KelayakanPengelolaan },
  { path: '/SertifikasiBudidayaIkan', name: 'SertifikasiBudidayaIkan', component: SertifikasiBudidayaIkan },
  { path: '/PembenihanIkan', name: 'PembenihanIkan', component: PembenihanIkan },
  { path: '/AngkutIkan', name: 'AngkutIkan', component: AngkutIkan },
  { path: '/TangkapIkan', name: 'TangkapIkan', component: TangkapIkan },
  { path: '/UsahaPerikanan', name: 'UsahaPerikanan', component: UsahaPerikanan },


  { path: '/DataUPTD', name: 'DataUPTD', component: DataUPTD },
  { path: '/DataPeraturan', name: 'DataPeraturan', component: DataPeraturan },


  { path: '/FotoOPD', name: 'FotoKB', component: FotoOPD },
  { path: '/VideoOPD', name: 'VideoKB', component: VideoOPD },
]

const router = createRouter({
  // eslint-disable-next-line no-unused-vars
  scrollBehavior(to, from, savedPosition) {
    return {
      top: 0,
      behavior: 'smooth'
     }
  },
  history: createWebHashHistory(),
  routes,
})

export default router
